import { render, staticRenderFns } from "./BaseParagraph.vue?vue&type=template&id=78e0d523&scoped=true"
import script from "./BaseParagraph.vue?vue&type=script&lang=js"
export * from "./BaseParagraph.vue?vue&type=script&lang=js"
import style0 from "./BaseParagraph.vue?vue&type=style&index=0&id=78e0d523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0d523",
  null
  
)

export default component.exports